export default "__VITE_ASSET__b685b71f__"